import React, { useState } from "react";
import { Collapse, Divider, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import palette from "src/theme/palette";
import dayjs from "dayjs";
import Chip from "@hyro-components/Chip";
import SubscriptionDetails from "./SubscriptionDetails";
import ProductsTable from "./ProductsTable";
import QuotasTable from "./QuotasTable";
import {
  RENEWAL_WARNING_CHIP_STYLE,
  RENEWAL_WARNING_DAYS_THRESHOLD
} from "./SubscriptionTab.consts";

const Card = styled(Stack)({
  backgroundColor: palette.system[0],
  border: "1px solid",
  borderColor: palette.system[200],
  borderRadius: 8,
  overflow: "hidden"
});

const RowHeader = styled(Stack)({
  height: 64,
  padding: "16px 24px",
  cursor: "pointer",
  flexDirection: "row",
  alignItems: "center",
  gap: 16
});

const TermRow = ({ opportunity, index, interactionLimit, interactionDefinition }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const startDate = dayjs(opportunity.closeDate).format("MMMM D, YYYY");
  const endDate = opportunity.renewalDate
    ? dayjs(opportunity.renewalDate).format("MMMM D, YYYY")
    : null;
  const dateRange = endDate ? `${startDate} - ${endDate}` : startDate;

  const daysUntilRenewal = opportunity.renewalDate
    ? dayjs(opportunity.renewalDate).diff(dayjs(), "day")
    : null;
  const showRenewalWarning = daysUntilRenewal !== null && daysUntilRenewal > 0 && daysUntilRenewal <= RENEWAL_WARNING_DAYS_THRESHOLD;

  const ChevronIcon = isExpanded ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;

  return (
    <Card data-testid={`term-row-${index}`}>
      <RowHeader data-testid={`term-row-header-${index}`} onClick={() => setIsExpanded((prev) => !prev)}>
        <ChevronIcon sx={{ color: palette.text[800] }} />
        <Typography variant="h6">Term {index + 1}</Typography>
        <Typography variant="body2" color="text.700">{dateRange}</Typography>
        {showRenewalWarning && (
          <Stack direction="row" gap={2} sx={{ ml: "auto" }}>
            <Chip
              label={`${daysUntilRenewal} days until renewal`}
              {...RENEWAL_WARNING_CHIP_STYLE}
            />
          </Stack>
        )}
      </RowHeader>
      <Collapse in={isExpanded} data-testid={`term-row-content-${index}`}>
        <Divider />
        <Stack gap={3} sx={{ p: 3 }}>
          <SubscriptionDetails opportunity={opportunity} />
          <ProductsTable products={opportunity.products || []} />
          <QuotasTable opportunity={opportunity} interactionLimit={interactionLimit} interactionDefinition={interactionDefinition} />
        </Stack>
      </Collapse>
    </Card>
  );
};

export default TermRow;
